﻿import React from 'react';
import { NavLink, useLocation } from 'react-router-dom'
import PropTypes from 'prop-types';
import { ShowHide } from 'components/layout';
import classNames from 'classnames';
import 'components/navigation/Navigation.css';

export function VerticalLink(
    {
        exactRouteMatch = true,
        externalLink = false,
        disabled = false,
        location,
        onChange,
        title
    }
) {
    const locationValue = useLocation();

    function checkIfRoutesMatch() {
        if (exactRouteMatch) {
            return location === locationValue.pathname;
        } else {
            let path = location.split('?')
            return locationValue.pathname.startsWith(path[0]);
        }
    }

    function onClick() {
        if (onChange) {
            onChange(title, location);
        }
    }

    return (
        <li className={classNames("bp6-tab", {"tab-disabled": disabled})} role="tab" aria-selected={checkIfRoutesMatch()}>
            <ShowHide
                evaluator={externalLink}
                show={(
                    <a href={location} onClick={onClick}>{title}</a>
                )}
                hide={(
                    <NavLink to={location} end onClick={onClick}>{title}</NavLink>
                )}
            />
        </li>
    );
}

VerticalLink.propTypes = {
    location: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    exactRouteMatch: PropTypes.bool,
    externalLink: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func
};
